import React, { useState, useEffect } from 'react';
import ReactMapGL, { NavigationControl, ViewportProps } from 'react-map-gl';
import useWindowSize from '../../hooks/useWindowSize';
import '../../App.css';
// import logoBlue from '../../assets/Logo-Blue.svg';
import OfficePopup from '../Popup/OfficePopup';
import { MarketData } from '../../types';
import CustomMarker from './Marker';
import { Dialog } from '@material-ui/core';

interface MapProps {
  marketData: MarketData[];
}

const Map = ({ marketData }: MapProps) => {
  const [viewport, setViewport] = useState<Partial<ViewportProps>>({
    latitude: 6.525963,
    longitude: 120.255119,
    zoom: 2.4,
    maxZoom: 4,
  });

  const [width, height] = useWindowSize();
  const [selectedMarket, setSelectedMarket] = useState<MarketData | null>();
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    if (selectedMarket) {
      setOpenDrawer(true);
    }
  }, [selectedMarket]);

  const handleClose = () => {
    setOpenDrawer(false);
    // Reset the viewport, since opening the drawer mutates it
    setViewport({
      ...viewport,
      latitude: 6.525963,
      longitude: 120.255119,
    });
    // Ensures animation runs before unmounting component.
    setTimeout(() => {
      setSelectedMarket(null);
    }, 500);
  };

  return (
    <>
      <ReactMapGL
        {...viewport}
        width={width}
        height={height}
        mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        mapStyle={process.env.REACT_APP_MAP_STYLE}
        onViewportChange={(nextViewport) => {
          setViewport(nextViewport);
        }}
      >
        {/* Render clickable markers on the map */}
        {marketData.map((market) => (
          <CustomMarker
            key={market.id}
            market={market}
            setSelectedMarket={setSelectedMarket}
            viewport={viewport}
            setViewport={setViewport}
          />
        ))}

        {/* Render popouts with information if a market is selected */}
        <React.Fragment key="right">
          <Dialog
            onClose={handleClose}
            open={openDrawer}
            transitionDuration={500}
            PaperProps={{
              style: { borderRadius: '25px' },
            }}
          >
            <OfficePopup
              selectedMarket={selectedMarket}
              setSelectedOffice={setSelectedMarket}
              handleClose={handleClose}
            />
          </Dialog>
        </React.Fragment>
        {/* Render the zoom buttons in the bottom right corner */}
        <div style={{ position: 'absolute', right: 20, bottom: 20 }}>
          <NavigationControl
            onViewportChange={(nextViewport) => {
              setViewport({ ...nextViewport });
            }}
          />
        </div>
      </ReactMapGL>
    </>
  );
};

export default Map;
